// @flow
import React from 'react';
import type { LineItem } from '../types';

//Item
import Item from './Item';

//Style
import './ItemList.css';

type Props = {
  items: LineItem[],
  handleRemoveItem: (lineItemId: number) => void,
  errors: string[],
  loading?: boolean,
};

const ItemList = ({ items, handleRemoveItem, errors, loading = false }: Props) => {

  const lineItemErrors = errors[0] && JSON.parse(errors[0]).errors;

  return (
    <div className="item-list-main">
      {items.map(item => (
        <Item
          item={item}
          key={item.id}
          productId={item.id}
          handleRemoveItem={handleRemoveItem}
          error={lineItemErrors?.[`line_items.${item.id}`]}
          loading={loading}
        />
      ))}
    </div>
  );
};

export default ItemList;
